// reducer.js
import * as actionTypes from "./actionsTypes";

const initialState = {
  currentPage: 1,
  value: "",

  statut: "",

  sortField: "date_initiale",
  order: "desc",
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VALUE_FACTURE:
      return {
        ...state,
        value: action.payload,
      };
    case actionTypes.SET_CURRENT_PAGE_FACTURE:
      return {
        ...state,
        currentPage: action.payload,
      };

    case actionTypes.SET_STATUT_FACTURE:
      return {
        ...state,
        statut: action.payload,
      };

    case actionTypes.SET_SORT_FIELD_FACTURE:
      return {
        ...state,
        sortField: action.payload,
      };
    case actionTypes.SET_ORDER_FACTURE:
      return {
        ...state,
        order: action.payload,
      };

    default:
      return state;
  }
};

export default rootReducer;
